import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55ac87fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalBackdrop flex absolute z-max" }
const _hoisted_2 = { class: "c4c-modal" }
const _hoisted_3 = { class: "panelheader" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headerTitle" }, "Department Summary Period Notes", -1))
const _hoisted_5 = { "aria-hidden": "true" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text" }, "Close", -1))
const _hoisted_7 = { class: "panleBody scrollBar" }
const _hoisted_8 = {
  id: "departmentsummary-notes-header",
  class: "txtLeft",
  style: {"width":"inherit"}
}
const _hoisted_9 = { class: "card shadow-sm mb-3 bg-white rounded" }
const _hoisted_10 = { class: "card-body position-relative" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-9" }
const _hoisted_13 = { class: "card-title mb-2" }
const _hoisted_14 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_15 = { class: "font-weight-bold" }
const _hoisted_16 = { class: "font-weight-bold" }
const _hoisted_17 = { class: "font-weight-bold" }
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-9 text-end" }, "Staff To:", -1))
const _hoisted_21 = { class: "col-md-3 font-weight-bold" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-9 text-end" }, "Actual:", -1))
const _hoisted_24 = { class: "col-md-3 font-weight-bold" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-9 text-end" }, "Forecast:", -1))
const _hoisted_27 = { class: "col-md-3 font-weight-bold" }
const _hoisted_28 = { class: "card shadow-sm mb-3 bg-white rounded content" }
const _hoisted_29 = {
  class: "card-body position-relative",
  style: {"overflow":"auto"}
}
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = { id: "departmentsummary-notes-container" }
const _hoisted_33 = {
  id: "departmentSummaryLoadingDiv",
  class: "loadingDiv1",
  style: {"padding":"5px","display":"none"}
}
const _hoisted_34 = {
  id: "actionable-content-loading",
  style: {"text-align":"center"}
}
const _hoisted_35 = { class: "fa-2x" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Saving...")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_AddViewNote = _resolveComponent("AddViewNote")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("a", {
          href: "#",
          class: "closeBtn neu-tooltip",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, [
          _createElementVNode("i", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'close'],
              size: "lg"
            })
          ]),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h6", _hoisted_13, _toDisplayString(_ctx.facilityName), 1),
                  _createElementVNode("h6", _hoisted_14, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.serviceLineName), 1),
                    _createTextVNode(" > "),
                    _createElementVNode("span", null, _toDisplayString(_ctx.departmentName), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['far', 'calendar'],
                      size: "sm",
                      class: "mr-2"
                    }),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.startDate), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['far', 'clock'],
                      size: "sm",
                      class: "mr-1"
                    }),
                    _createTextVNode(),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.startTime), 1),
                    _createTextVNode(" - "),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.endTime), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.staffTo), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.actualCensus), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.forecastCensus), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_AddViewNote)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_font_awesome_icon, {
                spin: true,
                icon: ['fas', 'circle-notch'],
                size: "lg"
              })
            ]),
            _hoisted_36
          ])
        ])
      ])
    ])
  ]))
}